<template>
  <div class="landing-wrapper df fdc aifs f1 w100p">

    <div v-if="currentTab == 'my-sessions'" class="my-sessions-popup">
      <img src="../../static/images/close-x.svg" @click="goToTab('upcoming')" class="close-menu">
      <div class="w100p">
        <h2 class="hosted-sessions-title">My Hosted Sessions</h2>
       <!--  <p v-if="sessions.length == 0">
          Click <span class="here" @click="newSession()">here</span> to start your first session.
        </p> -->
        <div v-if="loading" class="loading">Loading sessions...</div>
        <div v-else class="line-list w100p df fdc">
          <div class="whole-page-box-global-2-line-item line-item-header w100p df w100p jcsb aic">
              <p>Name</p>
              <p></p>
              <p>Status</p>
              <p>Last Edited</p>
              <p></p>
          </div>
          <div class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic"
                @click="goToProduct(product)"
                v-for="(product, i) in sessions"
                v-if="!product.deleted">
                <p>{{product.heading}}</p>
                <p>
                  <i v-if="product.enableChat" class="fal fa-comments-alt"></i>
                  <span v-else></span>

                  <i v-if="product.enableVideo" class="fab fa-youtube"></i>
                  <span v-else></span>
                </p>
                <p>Public</p>
                <p>{{formatDate(product.modified)}}</p>
                <p><i class="icon fal fa-edit"></i></p>
          </div>
          <div v-if="sessions.length == 0" class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic">
            <p>Start a cupping session to see it here</p>
          </div>
        </div>     
      </div>
    </div>

    <!-- <div class="top-bar-global w100p _position1 df jcsb aic breadcrumb-wrapper">
      <div class="breadcrumb df f1 posrel">
        <h2 class="breadcrumb-other" @click="goTo('/me')">Home</h2>
        <h2 class="breadcrumb-separator">-</h2>
        <h2>Cupping</h2>
      </div>
    </div> -->
    <div v-if="($store.getters['AUTH.myPrivateData'].type == 'alpha') || ($store.getters['AUTH.myPrivateData'].type == 'pro')" class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb0">
      <div class="title-box df">
        <h3 class="title-right">Start a cupping session</h3>
        <h4 class="button-1" @click="newSession()">
            </i>New Session
        </h4>
        <p class="see-all-sessions" @click="goToTab('my-sessions')">See all</p>
      </div>
    </div>
    <div v-else class="whole-page-box-global-2 whole-page-box-global-2-bigger w100p mb0">
      <div class="title-box df">
        <h3 class="title-right">Find and Explore Cupping Sessions</h3>
        <!-- <h4 class="button-1" @click="newSession()">
            </i>New Session
        </h4> -->
        <!-- <p class="see-all-sessions" @click="goToTab('my-sessions')">See all</p> -->
      </div>
    </div>

    <div class="sub-tabs df _s1 w100p" v-bind:class="{'sub-tabs-viewer': ($store.getters['AUTH.myPrivateData'].type !== 'alpha') && ($store.getters['AUTH.myPrivateData'].type !== 'pro')}">
<!--       <a class="upcoming-sessions" 
        @click="goToTab('upcoming-sessions')"
        v-bind:class="{'current-tab': currentTab == 'upcoming-sessions'}">
        Upcoming
      </a> -->
      <a class="recently-viewed-sessions" 
        @click="goToTab('saved')"
        v-bind:class="{'current-tab': currentTab == 'saved'}">
        Saved Sessions
      </a>

      <!-- <br/> -->
      <!-- <br/> -->

      <a class="recently-viewed-sessions" 
        @click="goToTab('upcoming')"
        v-bind:class="{'current-tab': currentTab == 'upcoming'}">
        Upcoming Events
      </a>

      <a class="recently-viewed-sessions" 
        @click="goToTab('previous')"
        v-bind:class="{'current-tab': currentTab == 'previous'}">
        Previous Events
      </a>

      <a class="recently-viewed-sessions" 
        @click="goToTab('recently-viewed-sessions')"
        v-bind:class="{'current-tab': currentTab == 'recently-viewed-sessions'}">
        Recently Viewed
      </a>

      <!-- <a class="my-sessions color-1" 
        v-if="($store.getters['AUTH.myPrivateData'].type == 'alpha') || ($store.getters['AUTH.myPrivateData'].type == 'pro')"
        @click="goToTab('my-sessions')"
        v-bind:class="{'current-tab': currentTab == 'my-sessions'}">
        My Hosted Sessions
      </a> -->
    </div>

    <div class="df fdc w100p">

      <div v-if="loading" class="loading">Loading sessions...</div>
      <div v-else-if="currentTab == 'recently-viewed-sessions'" class="w100p">
        <div class="line-list w100p df fdc">
          <div class="whole-page-box-global-2-line-item line-item-header w100p df w100p jcsb aic">
              <p>Name</p>
              <p>Host</p>
              <p></p>
              <p>Last Visited</p>
              <p></p>
          </div>
          <div class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic"
                @click="goTo('/live/' + product.orderId)"
                v-for="(product, i) in sessions"
                v-if="!product.deleted">
                <p>{{product.name}}</p> 
                <p>
                  <i v-if="product.enableChat" class="fal fa-comments-alt"></i>
                  <span v-else></span>

                  <i v-if="product.enableVideo" class="fab fa-youtube"></i>
                  <span v-else></span>
                </p>
                <p>{{product.hostName}}</p> 
                <p></p>
                <p>{{formatDate(product.lastVisited)}}</p>
                <!-- <p><i class="icon fal fa-eye"></i></p> -->
                <p class="view-session">view</p>
          </div>
          <div v-if="sessions.length == 0" class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic">
            <p>Join a cupping session to see it here</p>
          </div>

        </div>     
      </div>
      <div v-else-if="currentTab == 'upcoming'" class="w100p">
       <!--  <p v-if="sessions.length == 0">
          Click <span class="here" @click="newSession()">here</span> to start your first session.
        </p> -->
        <div class="line-list w100p df fdc">
          <div class="whole-page-box-global-2-line-item line-item-header w100p df w100p jcsb aic">
              <p>Name</p>
              <p>Starts</p>
              <p></p>
              <p></p>
              <p></p>
          </div>
          <div class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic"
                @click="goTo('/live/' + product.orderId)"
                v-for="(product, i) in sessions"
                v-if="!product.deleted">
                <p>{{product.heading}}</p>
                <p class="extra-text-outer"><span class="extra-text">Starts at</span> {{formatDate(product.startsAt)}}</p>
                <p>
                  <i v-if="product.enableChat" class="fal fa-comments-alt"></i>
                  <span v-else></span>

                  <i v-if="product.enableVideo" class="fab fa-youtube"></i>
                  <span v-else></span>
                </p>
                <p></p>
                <!-- <p><i class="icon fal fa-edit"></i></p> -->
                <p class="view-session">view</p>
          </div>
          <div v-if="sessions.length == 0" class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic">
            <p>No upcoming public cupping sessions. Check out <a target="_blank" href="https://www.instagram.com/cup.wise">@cup.wise</a> for future events!</p>
          </div>
        </div>     
      </div>
      <div v-else-if="currentTab == 'previous'" class="w100p">
       <!--  <p v-if="sessions.length == 0">
          Click <span class="here" @click="newSession()">here</span> to start your first session.
        </p> -->
        <div class="line-list w100p df fdc">
          <div class="whole-page-box-global-2-line-item line-item-header w100p df w100p jcsb aic">
              <p>Name</p>
              <p>Started</p>
              <p></p>
              <p></p>
              <p></p>
          </div>
          <div class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic"
                @click="goTo('/live/' + product.orderId)"
                v-for="(product, i) in sessions"
                v-if="!product.deleted">
                <p>{{product.heading}}</p>
                <p class="extra-text-outer"><span class="extra-text">Starts at</span> {{formatDate(product.startsAt)}}</p>
                <p>
                  <i v-if="product.enableChat" class="fal fa-comments-alt"></i>
                  <span v-else></span>

                  <i v-if="product.enableVideo" class="fab fa-youtube"></i>
                  <span v-else></span>
                </p>
                <p></p>
                <!-- <p><i class="icon fal fa-edit"></i></p> -->
                <p class="view-session">view</p>
          </div>
          <div v-if="sessions.length == 0" class="whole-page-box-global-2 whole-page-box-global-2-line-item w100p df w100p jcsb aic">
            <p>No upcoming public cupping sessions. Check out <a target="_blank" href="https://www.instagram.com/cup.wise">@cup.wise</a> for future events!</p>
          </div>
        </div>     
      </div>

    </div>
  </div>
</template>

<script>

import router from '../router'
import LandingProduct from '@/components/LandingProduct'

export default {
  name: 'Sessions',
  data () {
    return {
      loading: false,
      sessions: [],
      currentTab: 'upcoming',
      loading: true
    }
  },
  props: ['mode'],
  components: {
    LandingProduct
  },
  methods: {
    goToTab (tab) {
      console.log('GO TO', tab, tab == 'my-sessions')
      if (tab == 'my-sessions') {
        this.loading = true
        this.currentTab = tab
        this.getMySessions()
      } else if (tab == 'recently-viewed-sessions') {
        this.loading = true
        this.currentTab = tab
        this.getRecentSessions()
      } else if (tab == 'upcoming') {
        this.loading = true
        this.currentTab = tab
        this.getUpcomingSessions()
      } else if (tab == 'previous') {
        this.loading = true
        this.currentTab = tab
        this.getPreviousSessions()
      } 
    },
    getMySessions () {
      if (this.$store.getters['AUTH.uid']) {
        let _canUseMySessions = false

        if (['alpha','pro'].indexOf(this.$store.getters['AUTH.myPrivateData'].type > -1)) {
          _canUseMySessions = true
        }

        // this.$store.getters['AUTH.myPrivateData'].type == 'alpha' ? true : false
        if (_canUseMySessions) {
          this.$store.dispatch('AUTH.getMySessions', {}).then((res) => {
            let arr = res.mySessions
            arr = arr.filter((v) => v.modified)
            arr.sort((a, b) => {return b.modified - a.modified})
            this.sessions = arr
            this.loading = false
          })
        } else {
          this.currentTab = 'recently-viewed-sessions'
          this.getRecentSessions()
        }

      } else {
        console.log('wait')
        setTimeout(() => {
          this.getMySessions()
        }, 500)
      }
    },
    getRecentSessions () {
      if (this.$store.getters['AUTH.uid']) {
        this.$store.dispatch('AUTH.getRecentSessions', {}).then((res) => {
          let arr = res.mySessions
          console.log('ARR', arr)
          // arr = arr.filter((v) => v.modified)
          arr.sort((a, b) => {return b.modified - a.modified})
          console.log('a', arr)
          this.sessions = arr
          this.loading = false
        })
      } else {
        console.log('wait')
        setTimeout(() => {
          this.getRecentSessions()
        }, 500)
      }
    },
    getPreviousSessions () {
      if (this.$store.getters['AUTH.uid']) {
        this.$store.dispatch('AUTH.getPreviousSessions', {}).then((res) => {
          let arr = res.mySessions
          console.log('ARR', arr)
          // arr = arr.filter((v) => v.modified)
          arr.sort((a, b) => {return b.modified - a.modified})
          console.log('a', arr)
          this.sessions = arr
          this.loading = false
        })
      } else {
        console.log('wait')
        setTimeout(() => {
          this.getUpcomingSessions()
        }, 500)
      }
    },
    getPreviousSessions () {
      if (this.$store.getters['AUTH.uid']) {
        this.$store.dispatch('AUTH.getPreviousSessions', {}).then((res) => {
          let arr = res.mySessions
          console.log('ARR', arr)
          // arr = arr.filter((v) => v.modified)
          arr.sort((a, b) => {return b.modified - a.modified})
          console.log('a', arr)
          this.sessions = arr
          this.loading = false
        })
      } else {
        console.log('wait')
        setTimeout(() => {
          this.getPreviousSessions()
        }, 500)
      }
    },
    getUpcomingSessions () {
      if (this.$store.getters['AUTH.uid']) {
        this.$store.dispatch('AUTH.getUpcomingSessions', {}).then((res) => {
          let arr = res.mySessions
          console.log('ARR', arr)
          // arr = arr.filter((v) => v.modified)
          arr.sort((a, b) => {return b.modified - a.modified})
          console.log('a', arr)
          this.sessions = arr
          this.loading = false
        })
      } else {
        console.log('wait')
        setTimeout(() => {
          this.getUpcomingSessions()
        }, 500)
      }
    },
    newSession (product) {
      this.goTo('/add/' + 'live-session')
    },
    goTo (route) {
      router.push(route)
    },
    goToProduct (product) {
      console.log('product', product)
      let path = '/add/live-session/' + product.uniqueProductId
      router.push(path)
    },
    productTypeDisplay (type) {
      // let type = this.productType
      if (type == 'digital-download') {
        return 'Digital Download'
      } else if (type == 'digital-service') {
        return 'Service'
      } else if (type == 'calendar-event') {
        return 'Calendar Invite'
      }
      return ''
    },
    balance () {
      let balance = 0
      let income = this.income
      for (let item in income) {
        let earned = income[item].order[0].earned ? parseFloat(income[item].order[0].earned) : parseFloat(income[item].order[0].price)
        balance = balance + earned
      } 
      return parseFloat(balance/100).toFixed(2)
    },
    formatCurrency (c) {
      return (c/100).toFixed(2)
    },
    formatDate (date) {

      Number.prototype.padLeft = function(base,chr){
         var  len = (String(base || 10).length - String(this).length)+1;
         return len > 0? new Array(len).join(chr || '0')+this : this;
      }

      var d = new Date(date),
        dformat = [ (d.getMonth()+1).padLeft(),
                    d.getDate().padLeft(),
                    d.getFullYear()].join('/')+
                    ' ' +
                  [ d.getHours().padLeft(),
                    d.getMinutes().padLeft()].join(':');

               return dformat
    },
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Landing page created')
    this.getUpcomingSessions()
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  .landing-wrapper {
    padding: 19px;
    padding-top: 0px;
  }
  .landing-splash, .landing-choose-your-feel {
    width: 100%;
    max-width: 720px;
  }
  .landing-products {
    flex-wrap: wrap;
    max-width: 860px;
  }
  .balance-text {
    margin-right: 10px
  }
  .balance-amount {

  }
  .income-row {
    min-width: 100px;
    margin-bottom: 10px;
    height: 32px;

    p {
      font-family: 'CA SaygonText', sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    .income-heading {
      flex: 1;
      margin-right: 20px;
      display: flex;
      align-items: center;

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:nth-child(1) {
        width: 15%;
        max-width: 150px;
      }
      &:nth-child(2) {
        width: 15%;
      }
      &:nth-child(3) {
        width: 10%;
        max-width: 60px;
      }
      &:nth-child(4) {
        width: 15%;
        max-width: 200px;
      }
      &:nth-child(5) {
        width: 15%;
        max-width: 120px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .icon-product {
    color: #5469d4;
  }
  .income-heading {
    .with-icon {
      align-self: center;
      justify-self: center;
      text-align: center;
    }
  }
  .icon-product {
    font-size: 24px;
  }
  .one-product {
    h3 {
      margin-left: 8px;
    }
  }
  .whole-page-box-global {
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    /*cursor: pointer;*/
    max-width: 1000px;

    &:hover {
      /*background-color: #5469d4;*/
      /*border: none;*/

      h3, .icon-product, p {
        /*color: white;*/
      }
    }

    &:last-child {
      margin-right: 0;
    }

    &:last-child {
      /*margin-bottom: 0;*/
    }
  }

  .whole-page-box-global-2 {
    margin-bottom: 20px;
  }

  .new-product-wrap {

  }
  .created {
    font-size: 14px;
    margin-left: 20px;
  }
  .here {
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
    color: #5469d4;
  }
  .start-new-cupping {
    /*padding: 7px 18px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    /*right: 0;*/
    /*border: 1px solid $color-primary;*/
    margin-left: 20px;
    border-radius: 5px;
    position: relative;

    &:hover, &:active {
      p, i {
        z-index: 2;
      }
      &::before {
        position: absolute;
        left: -6px;
        top: -6px;
        content: ' ';
        width: calc(100% + 12px);
        height: 30px;
        border: 1px solid $color-primary;
        border-radius: 5px;
        z-index: 0;
      }
    }
  }
  .whole-page-box-global-2-line-item {
    &:hover {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
    }

    p {
      color: #49494C;
      font-family: Inter;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 17px;
      // text-align: right;
      &:first-child {
        flex: 1;
        width: 40%;
        color: #000000;
        font-family: Inter;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 17px;
      }
      &:nth-last-child(4) {
        /*width: 40%;*/
        /*width: 62px;*/
        width: 150px;
        display: flex;
        & > * {
          flex: 1;
          font-size: 20px;
        }
      }
      &:nth-last-child(3) {
        /*width: 40%;*/
        width: 60px;
        margin-left: 8px;
      }
      &:nth-last-child(2) {
        /*width: 40%;*/
        width: 140px;
        margin-left: 18px;
        margin-right: 14px;
      }
      &:last-child {
        width: 25px;
        font-size: 18px;
      }
    }
  }
  .whole-page-box-global-2-line-item {
    cursor: pointer;
    p {
      &:nth-last-child(3) {
        // font-size: 12px;
      }
      &:nth-last-child(2) {
        // font-size: 13px;
      }
    }
  }
  .hosted-sessions-title {
    margin-top: 12px;
    margin-bottom: 5px;
  }
  @media (max-width: 700px) {
    .whole-page-box-global-2-line-item.line-item-header {
      /*padding: 0px 27px 0px;*/
      margin: 0 30px;
      width: calc(100% - 60px);
    }
  }
  .extra-text {
    display: none;
  }
  @media (max-width: 640px) {
    .extra-text-outer {
      width: 100% !important;
      display: flex;
      justify-content: flex-start;
    }
    .extra-text {
      display: inline;
      font-size: 16px !important;
      line-height: 17px !important;
      margin-right: 6px;
      font-family: 'Inter';
      /*flex: unset !important;*/
    }
    .line-item-header {
      display: none;
    }
    .sub-tabs {
      margin-bottom: 15px !important;
    }
    .whole-page-box-global-2-line-item {
      min-height: 60px;
      height: unset;
      flex-wrap: wrap;
      justify-content: flex-end;
      padding-top: 8px;
      padding-bottom: 6px;
      p {
        &:first-child {
          width: 100%;
          /*height: 30px;*/
          min-width: 100%;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  h3 {
    /*color: #5C5C5C;*/
    font-family: Inter;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    .icon {
      margin-right: 6px;
    }
  }
  h4 {
    color: $color-primary;
    font-weight: 500;
    font-family: Inter;
    i {
      padding-right: 10px;
    }
  }

  .line-item-header {
    height: 44px;
    padding-top: 13px;
    margin-left: 57px;
    margin-right: 57px;
    margin-bottom: 2px;
    width: calc(100% - 114px);

    &:hover {
      box-shadow: none !important;
    }
  }
  .title-right {
    margin-right: 27px;
  }
  .mb0 {
    margin-bottom: 0;
    margin-bottom: 20px;
  }
  .see-all-sessions {
    cursor: pointer;
    margin-left: 20px;
    font-size: 14px;
    font-family: Inter;
    color: $color-primary;
    text-decoration: underline;
    font-weight: 500;
  }

  /* Page sub tabs */
  .sub-tabs {
    a {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 16px;
      margin-right: 47px;
      border-bottom: 5px solid transparent;
      padding-bottom: 8px;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        border-bottom: 5px solid #BEBEBE;
      }
    }
  }
  .current-tab {
    border-bottom: 5px solid #BEBEBE !important;
  }
  ._s1 {
    margin-top: 22px;
    margin-bottom: 6px;
  }
  .my-sessions {

  }
  .upcoming-sessions {

  }
  .recently-viewed-sessions {

  }
  .line-item-header {

  }
  .view-session {
    font-size: 14px !important;
    text-decoration: underline;
    cursor: pointer;
  }
  .fa-edit {
    font-size: 20px;
    margin-left: 15px;
  }
  .sub-tabs-viewer {
    margin-top: 0;
  }
  .my-sessions-popup {
    position: absolute;
    left: 0;
    z-index: 1111;
    background: grey;
    padding: 30px;
    width: 100%;
    top: 0;
    height: 100%;
    background-color: #efeff0;
  }
  .close-menu {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 25px;
    height: 25px;
  }
  @media (max-width: 420px) {
    .landing-wrapper {
      padding-left: 0;
      padding-right: 0;
    }

    .sub-tabs {
      padding-left: 15px;
      padding-right: 15px;
    }

    .whole-page-box-global-2-line-item {
      padding-top: 15px;
      padding-bottom: 15px;

      p {
        min-width: unset;

        &:nth-child(1) {
          margin-bottom: 8px;
        }
        &:nth-last-child(2) {
          font-size: 12px;
        }
        &:nth-last-child(3) {
          font-size: 12px;
        }
      }
      .fa-comments-alt {
        font-size: 16px !important;
      }
      .fa-edit {
        font-size: 22px;
      }
    }

    .whole-page-box-global {
      border-radius: 0;
    }
  }
  @media (max-width: 380px) {
    .whole-page-box-global-2-line-item {
      justify-content: flex-start;
      height: unset;
      p {
        width: 100%;
        margin-left: 0 !important;
        &:last-child {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .color-1 {
    /*color: $color-primary !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/Sessions.vue